/**
 * « Comment c'était ? » writes every verdict the moment its chip is tapped, and
 * « Enregistrer au journal » is the only button that marks the meal cooked. A
 * cook who answered « Adoré » and closed the sheet had said they cooked it and
 * was not believed (#865): the chips stayed lit, the meal stayed planned, and
 * the next « Comment c'était ? » asked again.
 *
 * Closing the sheet after answering now counts as the cook. Only an answer given
 * during this opening counts: a sheet opened on a recipe whose verdicts were
 * given last month and closed untouched says nothing about tonight.
 */

/** Something was answered or changed while the sheet was open, and an answer stands. */
export function verdictsAnsweredDuring(
  atOpen: Record<string, { value: unknown } | undefined>,
  atClose: Record<string, { value: unknown } | undefined>,
): boolean {
  const eaters = new Set([...Object.keys(atOpen), ...Object.keys(atClose)]);
  let changed = false;
  for (const eater of eaters) {
    if (atOpen[eater]?.value !== atClose[eater]?.value) changed = true;
  }
  return changed && Object.values(atClose).some((v) => v?.value != null);
}
